import React from 'react';
import { Users } from 'lucide-react';

interface PublishButtonProps {
  onClick: () => void;
}

const QueryButton: React.FC<PublishButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 z-30 flex items-center justify-center group"
      title="Publish Multiple Matches"
    >
      <Users size={24} className="group-hover:scale-110 transition-transform" />
    </button>
  );
};

export default QueryButton;